module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "page_normal--num_34--seq_51"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_normal--num_34--seq_51"
    }
  }), _c('div', {
    staticClass: "title-block",
    attrs: {
      "id": "section-chapter--num_34--seq_34"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_normal--num_34--seq_51"
    }
  }), _c('p', {
    staticClass: "title-num"
  }, [_c('a', {
    attrs: {
      "id": "page_normal--num_34--seq_51"
    }
  }), _c('a', {
    attrs: {
      "href": "#/a9781847673749_tableofcontents"
    }
  }, [_vm._v("CHAPTER 5. ")])]), _vm._v(" "), _c('h1', [_c('a', {
    attrs: {
      "href": "#/a9781847673749_tableofcontents"
    }
  }, [_vm._v("Rima ")])])]), _vm._v(" "), _c('p', {
    staticClass: "btn fp leading"
  }, [_vm._v("There was fog outside. The light from the windows saturated it so that the mansion seemed wrapped in a cocoon of milky light, but outside the cocoon Lanark walked in total obscurity and only found his way down the drive by the crunch of gravel underfoot and the touch of rimy leaves on his hands and face. ")]), _vm._v(" "), _c('p', [_vm._v("On the pavement it was possible to steer through the murk by the glow of the street lamp ahead. The clammy air made his footsteps resound loudly but after five minutes he decided that what seemed like echoes were the footsteps of someone behind. His back prickled apprehensively. He stood against a hedge and waited. The other footsteps hesitated, then came boldly on. In the fog’s cloudy dimness a shadow appeared and developed an unusual density of black, then the slim black figure of Rima passed by giving him only the flicker of a glance. He hurried after her crying gladly, “Rima! It’s me!” ")]), _vm._v(" "), _c('p', {
    staticClass: "btn fp"
  }, [_vm._v("“So I see.” ")]), _vm._v(" "), _c('p', {
    staticClass: "btn fp"
  }, [_vm._v("“Provost Dodd was looking for you.” ")]), _vm._v(" "), _c('p', {
    staticClass: "btn fp"
  }, [_vm._v("“Who’s Provost Dodd?” ")]), _vm._v(" "), _c('p', {
    staticClass: "btn fp"
  }, [_vm._v("The question seemed meant to stop conversation rather than aid it. He walked beside her, thinking of what he had seen of her friends in the bedroom. This memory no longer horrified. It combined with his words to the blond girl, with Gloopy’s disappearance and with the fog; it cast around her an odour of exciting malign sexual possibility. He asked abruptly, “Did you enjoy the party?” ")]), _vm._v(" "), _c('p', {
    staticClass: "btn fp"
  }, [_vm._v("“No.” ")]), _vm._v(" "), _c('p', {
    staticClass: "btn fp"
  }, [_vm._v("“What did you do?” ")]), _vm._v(" "), _c('p', {
    staticClass: "btn fp"
  }, [_vm._v("“If you must know I spent most of the time in the bathroom with Gay. She was very sick.” ")]), _vm._v(" "), _c('p', {
    staticClass: "btn fp"
  }, [_c('a', {
    attrs: {
      "id": "page_normal--num_35--seq_52"
    }
  }, [_vm._v("“Why?” ")])]), _c('a', {
    attrs: {
      "id": "page_normal--num_35--seq_52"
    }
  }, [_c('p', {
    staticClass: "btn fp"
  }, [_vm._v("“I don’t want to talk about it.” ")]), _vm._v(" "), _c('p', {
    staticClass: "btn fp"
  }, [_vm._v("“Do you want to talk to me at all?” ")]), _vm._v(" "), _c('p', {
    staticClass: "btn fp"
  }, [_vm._v("“No.” ")]), _vm._v(" "), _c('p', {
    staticClass: "btn fp"
  }, [_vm._v("His heart and penis hardened in angry amazement. He gripped her arms and pulled her round to face him saying softly, “Why?” She glared into his eyes and yelled, “Because I’m afraid of you!” ")]), _vm._v(" "), _c('p', {
    staticClass: "btn fp"
  }, [_vm._v("He was hit by a feeling of shame and weariness. He let her go, shrugging his shoulders and muttering, “Well, maybe that’s wise of you.” ")]), _vm._v(" "), _c('p', {
    staticClass: "btn fp"
  }, [_vm._v("Half a minute later he was surprised to find her walking beside him. She said, “I’m sorry.” ")]), _vm._v(" "), _c('p', {
    staticClass: "btn fp"
  }, [_vm._v("“Don’t be. Maybe I am a dangerous man.” ")]), _vm._v(" "), _c('p', {
    staticClass: "btn fp leading"
  }, [_vm._v("She began laughing but quickly smothered this and slipped a hand through his arm. The light pressure made him calmer and stronger. ")]), _vm._v(" "), _c('p', [_vm._v("They came to a street corner. The fog was very thick. A tramcar clanged past a few feet in front of them, but nothing could be seen of it. Rima said, “Where’s your coat? You’re shivering.” ")]), _vm._v(" "), _c('p', {
    staticClass: "btn fp"
  }, [_vm._v("“So are you. I’d take you for a coffee but I don’t know where we are.” ")]), _vm._v(" "), _c('p', {
    staticClass: "btn fp"
  }, [_vm._v("“You’d better come with me. I live nearby and I stole a bottle of brandy from the party.” ")]), _vm._v(" "), _c('p', {
    staticClass: "btn fp"
  }, [_vm._v("“You shouldn’t have done that.” ")]), _vm._v(" "), _c('p', {
    staticClass: "btn fp"
  }, [_vm._v("Rima withdrew her hand sharply and said, “You, are a very, big, wet, drip!” ")]), _vm._v(" "), _c('p', {
    staticClass: "btn fp"
  }, [_vm._v("Lanark was stung by this. He said, “Rima, I am not clever or imaginative. I have only a few rules to live by. These rules may annoy folk who are clever enough to live without them, but I can’t help that and you ought not to blame me.” ")]), _vm._v(" "), _c('p', {
    staticClass: "btn fp"
  }, [_vm._v("“All right, I’m sorry, I’m sorry, I’m sorry. You can make me apologize by breathing on me, it seems.” ")]), _vm._v(" "), _c('p', {
    staticClass: "btn fp"
  }, [_vm._v("They turned the corner. Lanark said, “But I can frighten you too.” ")]), _vm._v(" "), _c('p', {
    staticClass: "btn fp"
  }, [_vm._v("She was silent. ")]), _vm._v(" "), _c('p', {
    staticClass: "btn fp"
  }, [_vm._v("“And I can make you laugh.” ")]), _vm._v(" "), _c('p', {
    staticClass: "btn fp leading"
  }, [_vm._v("She laughed slightly and took his arm again. ")])]), _c('p', [_c('a', {
    attrs: {
      "id": "page_normal--num_35--seq_52"
    }
  }, [_vm._v("They seemed to enter a lane between low buildings like private garages. Rima unlocked a door, led him up a steep narrow wooden stair and switched a light on. Her austere man")]), _c('a', {
    attrs: {
      "id": "page_normal--num_36--seq_53"
    }
  }, [_vm._v("ner and clothing had made Lanark expect a stark room. This room was small, with a sloping ceiling and not much furniture, but there were many sad little personal touches. Childish crayon sketches of unconvincing green fields and blue seas were fixed to the walls. There was the only clock Lanark remembered seeing, carved and painted like a log cabin, with a pendulum below and a gilt weight shaped like a fir cone. The hands were missing. A stringless guitar lay on a chest of drawers and a teddy bear sat on the bed, which was a mattress on the floor against the wall. Rima clicked the switch of the electric radiator, removed her coat and became busy with a kettle and gas ring in a cupboard-sized scullery. There were no chairs, so Lanark sat on the floor and leaned on the bed. The radiator heated the small place so quickly that he was soon able to remove his fog-sodden jacket and jersey, yet though his skin was warm he was still shaken from inside by spasms of shivering. Rima carried in two large mugs of black coffee. She sat on the bed with her legs folded under her and handed a mug to Lanark saying, “You probably won’t refuse to drink it.” ")])]), _c('a', {
    attrs: {
      "id": "page_normal--num_36--seq_53"
    }
  }, [_c('p', {
    staticClass: "btn fp leading"
  }, [_vm._v("The coffee flavour was drowned by the taste of sugar and brandy. ")]), _vm._v(" "), _c('p', [_vm._v("Later Lanark lay back on the bed, feeling comfortable and slightly drunk. Rima, her eyes closed, rested her shoulders against the wall and cradled the teddy bear in her lap. Lanark said, “You’ve been kind to me.” ")]), _vm._v(" "), _c('p', {
    staticClass: "btn fp"
  }, [_vm._v("She stroked the old toy’s head. Lanark tried to think of other words. He said, “Did you come to this town long ago?” ")]), _vm._v(" "), _c('p', {
    staticClass: "btn fp"
  }, [_vm._v("“What does ‘long’ mean?” ")]), _vm._v(" "), _c('p', {
    staticClass: "btn fp"
  }, [_vm._v("“Were you very small when you came?” ")]), _vm._v(" "), _c('p', {
    staticClass: "btn fp"
  }, [_vm._v("She shrugged. ")]), _vm._v(" "), _c('p', {
    staticClass: "btn fp"
  }, [_vm._v("“Do you remember a time when days were long and bright?” Tears slid from under her closed lids. He touched her shoulders. ")]), _vm._v(" "), _c('p', {
    staticClass: "btn fp"
  }, [_vm._v("“Let me undress you?” ")]), _vm._v(" "), _c('p', {
    staticClass: "btn fp"
  }, [_vm._v("She allowed this. As he unfastened her brassière his hands met a familiar roughness. ")]), _vm._v(" "), _c('p', {
    staticClass: "btn fp"
  }, [_vm._v("“You’ve got dragonhide! Your shoulderblades are covered!” ")]), _vm._v(" "), _c('p', {
    staticClass: "btn fp"
  }, [_vm._v("“Does that excite you?” ")]), _vm._v(" "), _c('p', {
    staticClass: "btn fp"
  }, [_vm._v("“I have it too!” ")]), _vm._v(" "), _c('p', {
    staticClass: "btn fp"
  }, [_vm._v("She cried out harshly, “Do you think that makes a bond between us?” ")])]), _c('p', {
    staticClass: "btn fp leading"
  }, [_c('a', {
    attrs: {
      "id": "page_normal--num_36--seq_53"
    }
  }, [_vm._v("He shook his head urgently and placed a finger on her lips, feeling that words would move them farther apart. His anxiety to be tender to someone who needed and rejected tenderness ")]), _c('a', {
    attrs: {
      "id": "page_normal--num_37--seq_54"
    }
  }, [_vm._v("made his caresses clumsy, until genital eagerness sucked thought out of him. ")])]), _c('a', {
    attrs: {
      "id": "page_normal--num_37--seq_54"
    }
  }, [_c('p', [_vm._v("He felt relieved afterward and would have liked to sleep. He heard her rise briskly from his side and start dressing. She said curtly, “Well? Was it fun?” ")]), _vm._v(" "), _c('p', {
    staticClass: "btn fp"
  }, [_vm._v("He tried to think then said defiantly, “Yes. Great fun.” ")]), _vm._v(" "), _c('p', {
    staticClass: "btn fp"
  }, [_vm._v("“How nice for you.” ")]), _vm._v(" "), _c('p', {
    staticClass: "btn fp"
  }, [_vm._v("A nightmare feeling began to rise around him. He heard her say, “You’re not good at sex, are you? I suppose Sludden is the best I’ll ever get.” ")]), _vm._v(" "), _c('p', {
    staticClass: "btn fp"
  }, [_vm._v("“You told me that you didn’t …. love …. Sludden.” ")]), _vm._v(" "), _c('p', {
    staticClass: "btn fp"
  }, [_vm._v("“I don’t, but I use him sometimes. Just as he uses me. He and I are very cold people.” ")]), _vm._v(" "), _c('p', {
    staticClass: "btn fp"
  }, [_vm._v("“Why did you let me come here?” ")]), _vm._v(" "), _c('p', {
    staticClass: "btn fp"
  }, [_vm._v("“You wanted so much to be warm that I thought perhaps you were. You’re as cold as the rest of us, really, and even more worried about it. I suppose that makes you clumsy.” He was drowned in nightmare now, lying on the bottom of it as on an ocean bed, yet he could breathe. He said, “You’re trying to kill me.” ")]), _vm._v(" "), _c('p', {
    staticClass: "btn fp"
  }, [_vm._v("“Yes, but I won’t manage. You’re "), _c('i', [_vm._v("terribly")]), _vm._v(" solid.” ")]), _vm._v(" "), _c('p', {
    staticClass: "btn fp"
  }, [_vm._v("She finished dressing and slapped his cheek briskly saying, “Come on. I can’t apologize to you again. Get up and get dressed.” ")]), _vm._v(" "), _c('p', {
    staticClass: "btn fp"
  }, [_vm._v("She stood with her back against the chest of drawers, watching while he slowly dressed, and when he finished she said inexorably, “Goodbye, Lanark.” ")]), _vm._v(" "), _c('p', {
    staticClass: "btn fp leading"
  }, [_vm._v("All his feelings were numbed but he stood a moment, staring stupidly at her feet. She said, “Goodbye, Lanark!” and gripped his arm and led him to the door, and pushed him out and slammed it. ")]), _vm._v(" "), _c('p', {
    staticClass: "btn leading"
  }, [_vm._v("He groped his way downstairs. Near the bottom he heard her open the door and shout “Lanark!” He looked back. Something dark and whirling came down on his head, heavily enfolding it, and again the door slammed. He dragged the thing off and found it was a sheepskin jacket with the fleece turned inward. He hung this on the inside knob of the bottom door and stepped into the lane and walked away. ")])]), _c('p', {
    staticClass: "btn leading"
  }, [_c('a', {
    attrs: {
      "id": "page_normal--num_37--seq_54"
    }
  }, [_vm._v("After a time the dense freezing fog and his arctic brain and body blended. He moved along streets in them, a numb kernel of soul kept going by feet somewhere underneath. The ")]), _c('a', {
    attrs: {
      "id": "page_normal--num_38--seq_55"
    }
  }, [_vm._v("only thing he felt very conscious of was his itching right arm, and several times he stopped and rubbed it backward and forward against corners of walls to scratch it through the sleeve. The sounds and lights of tramcars passed him frequently now, and after crossing a street he was puzzled by a complicated shape between himself and the flow of a high lamp. Going nearer he discerned a queen with a long train riding side-saddle on a rearing horse. It was a statue in the great square. He considered going for warmth to the security office but decided he needed something to drink. He crossed other streets till he saw red neon shining above the pavement. He opened the tinkling door of a small aromatic tobacconist shop, crossed to a staircase and went down into Galloway’s Tearoom. This was a low-ceilinged place much bigger than the shop upstairs. Most of it was alcoves, some opening from others, each with a sofa, table and chairs in it and a stag’s head on a plaque. Lanark ordered lemon tea, sat in the corner of a sofa and fell asleep. ")])]), _c('a', {
    attrs: {
      "id": "page_normal--num_38--seq_55"
    }
  }, [_c('p', [_vm._v("He awoke long afterward. The glass of tea was cold on the table before him and he was listening to a conversation between two businessmen. His ear was an inch from a thick brown curtain separating his sofa from where they sat and clearly they had no sense of being overheard. ")]), _vm._v(" "), _c('p', {
    staticClass: "btn fp"
  }, [_vm._v("“… Dodd is on our side. After all, the Corporation has nothing to do but light the streets and keep the trams running, and these services don’t pay for themselves. They have to be subsidized by the sale of municipal property, so Dodd is selling and I’m buying.” ")]), _vm._v(" "), _c('p', {
    staticClass: "btn fp"
  }, [_vm._v("“But what will you do with it?” ")]), _vm._v(" "), _c('p', {
    staticClass: "btn fp"
  }, [_vm._v("“Sublet. The smallest of these rooms could contain sixteen single apartments if we divided them up with matchboard partitions. I’ve measured.” ")]), _vm._v(" "), _c('p', {
    staticClass: "btn fp"
  }, [_vm._v("“Don’t be mad! Why should anyone want a tiny apartment just because it’s on the square? There’s no profit in being a landlord with a third of the city standing empty.” ")]), _vm._v(" "), _c('p', {
    staticClass: "btn fp"
  }, [_vm._v("“No profit at the moment. I mean to sublet these eventually.” ")]), _vm._v(" "), _c('p', {
    staticClass: "btn fp"
  }, [_vm._v("“Don’t be mysterious, Aitcheson. You can trust me.” ")]), _vm._v(" "), _c('p', {
    staticClass: "btn fp"
  }, [_vm._v("“All right. You know the population is smaller than it used to be. Have you faced the fact that it gets smaller all the time?” ")]), _vm._v(" "), _c('p', {
    staticClass: "btn fp"
  }, [_vm._v("“Why?” ")]), _vm._v(" "), _c('p', {
    staticClass: "btn fp"
  }, [_vm._v("“You know why.” ")]), _vm._v(" "), _c('p', {
    staticClass: "btn fp"
  }, [_vm._v("There was a silence. “What about the new arrivals?” ")]), _vm._v(" "), _c('p', {
    staticClass: "btn fp"
  }, [_vm._v("“Not enough of them. You live in a hotel, don’t you?” ")]), _vm._v(" "), _c('p', {
    staticClass: "btn fp"
  }, [_vm._v("“Of course.” ")])]), _c('p', {
    staticClass: "btn fp"
  }, [_c('a', {
    attrs: {
      "id": "page_normal--num_38--seq_55"
    }
  }), _c('a', {
    attrs: {
      "id": "page_normal--num_39--seq_56"
    }
  }, [_vm._v("“Of course. So do I. Nobody notices disappearances in a hotel. In the normal way you expect the man in the next room to disappear after a while. Life is different in a tenement. Suddenly the house across the landing is empty. A little later the one upstairs goes empty too. Then you notice there are no lights in half the windows across the street. It’s disturbing! Mind you, people are still pretending not to notice. Wait till they have no neighbours left. Wait till they’re lonely and the panic starts! They’ll crowd to the city centre like drowning men onto a raft. If the city chambers are still empty they’ll break in and squat. But they won’t be empty because I’ll be subletting them.” ")])]), _c('a', {
    attrs: {
      "id": "page_normal--num_39--seq_56"
    }
  }, [_c('p', {
    staticClass: "btn fp"
  }, [_vm._v("After a pause, the other voice said grudgingly, “Very clever. But aren’t you being a bit optimistic? You’re gambling on a trend that may not continue.” ")]), _vm._v(" "), _c('p', {
    staticClass: "btn fp leading"
  }, [_vm._v("“What is there to stop it?” ")]), _vm._v(" "), _c('p', [_vm._v("Lanark stood up, feeling terribly afraid. A short while ago he had told Sludden he was content. Now everything he heard or saw or remembered was pushing him toward panic. He desperately wanted Rima beside him, a Rima who would smile and be sad with him, a Rima whose fears he could soothe and who would not fling words at him like stones. He paid for the tea and went back to his own room and undressed. When jacket and jersey were removed he saw the right shirtsleeve was stiff with dried blood, and on taking off the shirt he found the arm was dragonhide from shoulder to wrist, with spots of it on the back of his hand. He put on his pyjamas, got into bed and fell asleep. There seemed nothing else to do. ")])])]), _c('a', {
    attrs: {
      "id": "page_normal--num_39--seq_56"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-edc607f6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/a9781847673749_chapter_06.vue
// module id = 96
// module chunks = 0